"use client";

import { hasLength, isEmail, useForm } from "@mantine/form";
import { useCustomer } from "@/contexts/customerContext";
import { Button, PasswordInput, TextInput } from "@mantine/core";
import Link from "next/link";
import { Icon } from "@iconify/react";
import { useState } from "react";
import { useCart } from "@/contexts/cartContext";
export default function CheckoutLoginForm({
  onClose
}) {
  const {
    refreshCustomer
  } = useCustomer();
  const {
    dispatchCartEvent
  } = useCart();
  const [loading, setLoading] = useState(false);
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      email: "",
      password: ""
    },
    validate: {
      email: isEmail('Invalid email'),
      password: hasLength({
        min: 5
      }, 'Password is too short')
    }
  });
  const handleSubmit = async values => {
    setLoading(true);
    try {
      const res = await fetch("/api/customer/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: values.email,
          password: values.password
        })
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || "Login failed");
      }
      const data_0 = await res.json();
      await refreshCustomer();
      await handleCustomerAttach(data_0.customer);
      onClose?.();
    } catch (err) {
      form.setErrors({
        email: '',
        password: "Invalid email or password"
      });
    } finally {
      setLoading(false);
    }
  };
  const handleCustomerAttach = async customerData => {
    if (!customerData) return;
    try {
      await dispatchCartEvent({
        type: "customer_attached",
        customer_id: customerData.customer_id,
        address_id: customerData?.address_id,
        email: customerData.email
      });
    } catch (e) {
      console.error("Customer attach failed", e);
    }
  };
  return <form onSubmit={form.onSubmit(handleSubmit)}>
            <TextInput radius={'xs'} leftSection={<Icon icon={'mdi:email'} />} size={'md'} mb={'md'} label="Your email" placeholder="Your email" withAsterisk key={form.key('email')} {...form.getInputProps('email')} />
            <PasswordInput radius={'xs'} leftSection={<Icon icon={'mdi:lock'} />} size={'md'} withAsterisk label="Password" placeholder="Your password" description="Secure your account" key={form.key('password')} {...form.getInputProps('password')} />
            <div className={'flex items-center justify-between mt-4'}>
                <Button loading={loading} type="submit" color={'green.8'} miw={100}>Log In</Button>
                <Link href="/auth/forget-password" className={'text-blue-700 text-sm'}>Forgot Your Password?</Link>
            </div>
        </form>;
}